export function levelsInfo(state) {
    const data = state.charts_data.levels
    const quantity = state.charts_data.quantity
    return {
        level_1: data.length ? (data[0]['data'] / quantity) * 100 : 0,
        level_2: data.length ? (data[1]['data'] / quantity) * 100 : 0,
        level_3: data.length ? (data[2]['data'] / quantity) * 100 : 0,

    }
}
